import React from 'react';
import InfoPage from '../components/InfoPage';

const EFFECTIVE_DATE = 'August 8, 2026';
const SUPPORT_EMAIL = 'support@kinetocut.com';

export default function PrivacyPolicy() {
  return (
    <InfoPage
      eyebrow="Legal"
      title="Privacy Policy"
      subtitle="What KinetoCut collects, why, and the choices you have."
      icon="◉"
      aside={(
        <>
          <span className="card-kicker">Document status</span>
          <h2>Effective {EFFECTIVE_DATE}</h2>
          <p>This policy applies to the KinetoCut website, account system, and mobile apps.</p>
          <div className="aside-note"><span>✓</span><p>Your photos, videos, and audio are never uploaded to our servers.</p></div>
        </>
      )}
    >
      <section>
        <h2>Overview</h2>
        <p>KinetoCut ("we", "us", "our") builds a video editing app and the account tools on this website. This policy explains what information we collect when you create an account or use KinetoCut, how it is used, and how you can control it.</p>
      </section>
      <section>
        <h2>Information we collect</h2>
        <p><strong>Account information.</strong> When you register, we collect your name and email address, and whether you signed up with a password, Google, or Apple. If you sign in with Google or Apple, we receive the basic profile details those providers share (typically name and email).</p>
        <p><strong>Your media.</strong> KinetoCut edits the photos, videos, and audio you select directly on your device. Source media is treated as read-only and is never uploaded, copied to our servers, or transmitted to us. Exported files stay on your device unless you choose to share them yourself.</p>
        <p><strong>Technical information.</strong> Our hosting and authentication providers automatically log standard technical data (such as IP address and request timestamps) to keep the service secure and reliable. We do not use this data for advertising.</p>
      </section>
      <section>
        <h2>How we use information</h2>
        <p>We use account information to create and secure your account, let you sign in across devices, display your name in the app, and respond when you contact support. We do not sell personal information, and we do not use your data for third-party advertising.</p>
      </section>
      <section>
        <h2>Where information is stored</h2>
        <p>Account data is stored using Firebase Authentication and Cloud Firestore, services provided by Google. These providers apply industry-standard security controls, including encryption in transit. Access to account data is limited to what is needed to operate KinetoCut.</p>
      </section>
      <section>
        <h2>Third-party services</h2>
        <p>We rely on Firebase (Google) for authentication, data storage, and website hosting, and on Sign in with Google and Sign in with Apple for optional social login. These providers process data under their own privacy policies in addition to this one.</p>
      </section>
      <section>
        <h2>Data retention and deletion</h2>
        <p>We keep account information for as long as your account is active. You can update your name from your profile page at any time. To delete your account and associated data, email <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> from the address on your account, and we will process the request within a reasonable time.</p>
      </section>
      <section>
        <h2>Children's privacy</h2>
        <p>KinetoCut is not directed to children under 13, and we do not knowingly collect personal information from children under 13. If you believe a child has created an account, contact us and we will remove it.</p>
      </section>
      <section>
        <h2>Your choices and rights</h2>
        <p>Depending on where you live, you may have the right to access, correct, export, or delete your personal information. You can exercise these rights by emailing <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.</p>
      </section>
      <section>
        <h2>Changes to this policy</h2>
        <p>We may update this policy as KinetoCut evolves. Material changes will be reflected by updating the effective date above. Continued use of KinetoCut after a change means you accept the updated policy.</p>
      </section>
      <section>
        <h2>Contact us</h2>
        <p>Questions about this policy can be sent to <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.</p>
      </section>
    </InfoPage>
  );
}
